<div class="tw-flex tw-flex-col">
  <div class="tw-flex tw-items-center tw-p-5 tw-border-b tw-border-b-b2 tw-justify-between">
    <h6 class="tw-text-color-1">Don’t have a DEMAT Account?</h6>
    <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="closeDialog()"
      aria-label="Close Dialog">
      <common-icons iconName="x" class="tw-cursor-pointer tw-w-5 tw-h-5 tw-text-color-1"></common-icons>
    </button>
  </div>
  <p class="tw-w-full tw-p-5 tw-para-2 tw-text-color-2 tw-max-w-[600px]">Demat account is
    mandatory for purchasing equity, You can go ahead with any of our connected brokers to open paperless account, Its
    just 3 min process.</p>
  <div class="tw-flex tw-flex-wrap tw-p-5">
    <button type="button"
      class="tw-bg-transparent tw-border-0 tw-p-0 tw-flex tw-flex-col tw-items-center tw-para-2 tw-font-semibold tw-text-color-1 tw-mr-8 tw-mb-6 tw-cursor-pointer"
      (click)="goTo('zerodha')">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-border tw-border-b2 tw-rounded-full tw-mb-2.5 tw-overflow-hidden">
        <img class="tw-h-12 tw-w-12" src="assets/new-images/partner/zerodha.svg" alt="zerodha">
      </div>
      Zerodha
    </button>
    <button type="button"
      class="tw-bg-transparent tw-border-0 tw-p-0 tw-flex tw-flex-col tw-items-center tw-para-2 tw-font-semibold tw-text-color-1 tw-mr-8 tw-mb-6 tw-cursor-pointer"
      (click)="goTo('master_trust_login')">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-border tw-border-b2 tw-rounded-full tw-mb-2.5 tw-overflow-hidden">
        <img src="assets/new-images/partner/mastertrust.svg" class="tw-h-full" alt="master_trust">
      </div>Master Trust
    </button>
    <button type="button"
      class="tw-bg-transparent tw-border-0 tw-p-0 tw-flex tw-flex-col tw-items-center tw-para-2 tw-font-semibold tw-text-color-1 tw-mr-8 tw-mb-6 tw-cursor-pointer"
      (click)="goTo('five_paisa_login')">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-border tw-border-b2 tw-rounded-full tw-mb-2.5 tw-overflow-hidden">
        <img src="assets/new-images/five-paisa-logo.png" class="tw-h-full" alt="five_paisa">
      </div>5 Paisa
    </button>
    <button type="button"
      class="tw-bg-transparent tw-border-0 tw-p-0 tw-flex tw-flex-col tw-items-center tw-para-2 tw-font-semibold tw-text-color-1 tw-mr-8 tw-mb-6 tw-cursor-pointer"
      (click)="goTo('klever_trade')">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-border tw-border-b2 tw-rounded-full tw-mb-2.5 tw-overflow-hidden">
        <img src="assets/partner/klever-trade.png" class="tw-h-[35px] tw-object-contain" alt="klever_trade">
      </div>Klever Trade
    </button>
    <button type="button"
      class="tw-bg-transparent tw-border-0 tw-p-0 tw-flex tw-flex-col tw-items-center tw-para-2 tw-font-semibold tw-text-color-1 tw-mr-8 tw-mb-6 tw-cursor-pointer"
      (click)="goTo('aditya_birla')">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-border tw-border-b2 tw-rounded-full tw-mb-2.5 tw-overflow-hidden">
        <img src="assets/partner/aditya-birla.svg" class="tw-h-full tw-object-contain" alt="aditya_birla">
      </div>Aditya Birla
    </button>
    <button type="button"
      class="tw-bg-transparent tw-border-0 tw-p-0 tw-flex tw-flex-col tw-items-center tw-para-2 tw-font-semibold tw-text-color-1 tw-mr-8 tw-mb-6 tw-cursor-pointer"
      (click)="goTo('nuvama')">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-border tw-border-b2 tw-rounded-full tw-mb-2.5 tw-overflow-hidden">
        <img src="assets/partner/nuvama.png" class="tw-h-full tw-object-contain" alt="nuvama">
      </div>Nuvama
    </button>
    <button type="button"
      class="tw-bg-transparent tw-border-0 tw-p-0 tw-flex tw-flex-col tw-items-center tw-para-2 tw-font-semibold tw-text-color-1 tw-mr-8 tw-mb-6 tw-cursor-pointer"
      (click)="goTo('bajaj')">
      <div
        class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-border tw-border-b2 tw-rounded-full tw-mb-2.5 tw-overflow-hidden">
        <img src="assets/partner/10.png" class="tw-h-full" alt="bajaj">
      </div>Bajaj
    </button>
  </div>
</div>